import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link as MuiLink, Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import { Link as RouterLink } from 'react-router-dom'

import { COLORS } from 'config/constants'

import './notification-body-content.scss'

import { applicationDetailPath } from 'utils/applicationRoutes'

import {
  applicationLinkPath,
  legacyApplicationUrlFromBody,
  notificationBodyText,
} from './notification-body-utils'

const NotificationBodyContent = ({
  body,
  applicationId,
  applicationUrl,
  variant = 'body1',
  onApplicationLinkClick,
}: CommonNotificationBodyContentProps) => {
  const { t } = useTranslation()
  const text = notificationBodyText(body)
  const href = applicationLinkPath(applicationUrl || legacyApplicationUrlFromBody(body))
    || (applicationId ? applicationDetailPath({ publicId: applicationId }) : null)

  const body1TextSx: SxProps<Theme> = {
    color: COLORS.BLACK_DARK,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: 0,
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
  }
  const body2TextSx: SxProps<Theme> = {
    color: COLORS.LIGHT_TEXT_DISABLED,
    lineHeight: '21px',
    letterSpacing: 0,
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
  }
  const textSx = variant === 'body1' ? body1TextSx : body2TextSx

  return (
    <div className='notification-body-content'>
      {text && (
        <Typography variant={variant} sx={textSx}>
          {text}
        </Typography>
      )}
      {href && (
        <MuiLink
          component={RouterLink}
          to={href}
          underline='hover'
          sx={{
            display: 'inline-block',
            mt: text ? 1 : 0,
            color: COLORS.BLUE,
            fontSize: variant === 'body1' ? 16 : 14,
            lineHeight: variant === 'body1' ? '24px' : '21px',
          }}
          onClick={onApplicationLinkClick}
        >
          <Typography component='span' variant={variant} sx={{ fontSize: 'inherit', lineHeight: 'inherit', letterSpacing: 'inherit' }}>
            {t('notifications__text__openApplication')}
          </Typography>
        </MuiLink>
      )}
    </div>
  )
}

export default NotificationBodyContent
